class ModuleSidebarProfilloisirs {

  private toggle: HTMLInputElement;
  private shareLoisirs!: HTMLDivElement;
  private notshareLoisirs!: HTMLDivElement;
  private sideBar!: HTMLDivElement;
  private closeButtons!: NodeListOf<Element>;
  private rgpd!: HTMLInputElement;
  private acceptButton!: HTMLButtonElement;

  constructor() {
    this.toggle = document.querySelector(
      '[data-open-sidebar-profil-loisirs]'
    ) as HTMLInputElement;

    if (this.toggle) {
      this.shareLoisirs = document.querySelector('.share-loisirs') as HTMLDivElement;
      this.notshareLoisirs = document.querySelector('.not-share-loisirs') as HTMLDivElement;
      this.sideBar = document.getElementById('sidebar-profil-loisirs') as HTMLDivElement
      this.closeButtons = document.querySelectorAll('[data-close-sidebar-profil-loisirs]') as NodeListOf<Element>;
      this.rgpd = document.querySelector('[data-rgpd-sidebar-profil-loisirs]') as HTMLInputElement
      this.acceptButton = document.querySelector('[data-valid-sidebar-profil-loisirs]') as HTMLButtonElement
      this._init();
    }
  }

  _init() {

    // Toggle de la checkbox
    this.toggle.addEventListener('click', () => {
      if (this.toggle.checked) {
        // Ouverture de la sidebar
        this._toggleSidebar();
      } else {
        this._setShareloisirs(false)
      }
    });

    // Case RGPD
    this.rgpd.addEventListener('change', () => {
      this.acceptButton.disabled = !this.rgpd.checked;
    })

    // Validation
    this.acceptButton.addEventListener('click', (e) => {
      e.preventDefault();
      if (this.rgpd.checked) {
        this._setShareloisirs(true);
      }
    })

    // Fermeture de la sidebar
    if (this.closeButtons) {
      this.closeButtons.forEach((close) => {
        close.addEventListener('click', this._hideSidebar.bind(this));
      });
    }
  }

  _toggleSidebar() {
    if (this.sideBar) {
      this.sideBar.classList.toggle('open');
      if (this.sideBar.classList.contains('open')) {
        this.rgpd.checked = false
        this.acceptButton.disabled = true;
        document.body.classList.add('sidebar-open');
      } else {
        document.body.classList.remove('sidebar-open');
      }
    }
  }

  _hideSidebar() {
    if (this.sideBar && this.sideBar.classList.contains('open')) {
      // Retour à l'ancien état
      this.toggle.checked = !this.toggle.checked;
      if (this.toggle.checked) {
        this.shareLoisirs.classList.remove('hidden')
        this.notshareLoisirs.classList.add('hidden')
      } else {
        this.shareLoisirs.classList.add('hidden')
        this.notshareLoisirs.classList.remove('hidden')
      }
      this.sideBar.classList.remove('open');
      document.body.classList.remove('sidebar-open');
    }
  }

  async _setShareloisirs(share: boolean) {
    const formData = new FormData();
    formData.append("action", "user_share_loisirs");
    formData.append("nonce", (window as any).ajax.nonce);
    formData.append("share", share ? 'true' : 'false');


    try {
      const response = await fetch((window as any).ajax.ajax_url, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();

      if (result.success) {
        if (share == true) {
          this.shareLoisirs.classList.remove('hidden')
          this.notshareLoisirs.classList.add('hidden')
        } else {
          this.shareLoisirs.classList.add('hidden')
          this.notshareLoisirs.classList.remove('hidden')
        }
        this.sideBar.classList.remove('open');
        document.body.classList.remove('sidebar-open');
      } else {
        this.toggle.checked = !share;
        console.error("Erreur lors de la suppression :", result.data);
      }
    } catch (error) {
      console.error("Erreur réseau ou serveur :", error);
    }
  }
}

export const moduleSidebarProfilloisirs = new ModuleSidebarProfilloisirs();
